import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled, { css } from 'styled-components';

import { breakpoints } from '../../../lib/constants';
import { GrayBox } from '../skylab/box';

export const FieldDefaults = css`
  input,
  select,
  textarea {
    margin-bottom: 20px;
  }
`;

export const CheckedUL = styled.ul`
  && {
    margin-left: 0;
  }
  > li {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-start: left;

    s-icon {
      margin-right: 8px;
      color: ${COLORS.darkOrange};
    }
  }
`;

export const FieldErrorMessage = styled.div`
  display: block;
  width: 100%;
  padding: 3px 5px 3px 0;
  margin: -15px 0 5px;
  p {
    color: ${COLORS.alertRed};
    font-size: .9em;
    text-transform: unset;
    margin-bottom: 5px;
  }
  &:before,
  &:after {
    display: table;
    width: 100%;
    content: '';
    visibility: hidden;
  }
`;

export const RightColumn = styled(GrayBox)`
  margin-bottom: 30px;

  @media (max-width: ${breakpoints.phone}px) {
    width: 100%;
  }
`;

export const NoListStyleUl = styled.ul`
  && {
    list-style: none;
    margin-left: 0;

    li {
      margin-bottom: .4em;
      ${(props: { darkBlue?: boolean }) => (props.darkBlue ? `color: ${COLORS.darkBlue}` : '')}
    }

    &.more-space {
      li {
        margin-bottom: 1.05em;
      }
    }
  }
`;

export const SignUpForm = styled.div`
  && {
    margin-top: 1.285em;
  }

  i, b {
    font-size: 12px;
  }
  ${FieldDefaults}
`;

export const FormInput = styled.input<{ isInvalid: boolean; marginAboveError: string }>`
  ${({ isInvalid }) => (isInvalid ? 'outline-color: red; box-shadow: 0 0 3px red;' : '')}
  ${({ marginAboveError }) => (marginAboveError ? `margin-bottom: ${marginAboveError}` : '')}
`;

export const SelectInput = styled.select<{ isInvalid?: boolean }>`
${({ isInvalid }) => (isInvalid ? 'outline-color: red; box-shadow: 0 0 3px red;' : '')}
`;
